import { MFChannel } from '../../../Components/SDK';
import { getMessageById } from '../../../Slice';
import { getLocalUserDetails } from '../commonActions';
import { showErrorToast } from '../toast';

export const sendReaction = async ({ channelId, messageId, reaction }) => {
   const localUser = getLocalUserDetails();
   const message = getMessageById(channelId, messageId);

   if (!localUser || !message) {
      console.warn('User or message not found.');
      return;
   }

   const userId = localUser.userId;
   const existingReactions = message.reactions || {};
   const existingReaction = existingReactions[reaction];

   // Check if the user already reacted with this emoji
   const hasReacted = existingReaction?.users?.includes(userId);
   const remove = !!hasReacted;

   try {
      const res = await MFChannel.react({
         channelId,
         messageId,
         reaction,
         remove,
      });

      if (res.statusCode !== 200) {
         showErrorToast(res.message);
      }
   } catch (error) {
      console.error('Failed to send reaction:', error);
   }
};
